import { Injectable, inject } from "@angular/core";
import { ConsentStatus, ConsentType, FirebaseAnalytics } from "@capacitor-firebase/analytics";
import { AnalyticsEvent, CustomDimensions } from "@constants";
import { INTERFACE } from "@interfaces/general";
import { Utils } from "@shared-utils/Utils";

@Injectable({
  providedIn: "root",
})
export class AnalyticsService {
  private utils = inject(Utils);
  trackNavigation(path: string) {
    if (!this.utils.isPluginAvailable("FirebaseAnalytics")) {
      return;
    }
    FirebaseAnalytics.setCurrentScreen({ screenName: path });
  }

  trackEvent(event: AnalyticsEvent, params: Partial<Record<CustomDimensions, string | number>> = {}) {
    if (!this.utils.isPluginAvailable("FirebaseAnalytics")) {
      return;
    }

    FirebaseAnalytics.logEvent({
      name: event,
      params,
    });
  }

  initializeAnalytics() {
    if (!this.utils.isPluginAvailable("FirebaseAnalytics")) {
      return;
    }
    return FirebaseAnalytics.setEnabled({
      enabled: true,
    });
  }

  async setConsent(data: INTERFACE.ConsentOptionsData) {
    if (!this.utils.isPluginAvailable("FirebaseAnalytics")) {
      return;
    }
    try {
      await Promise.all([
        FirebaseAnalytics.setConsent({
          type: ConsentType.AdStorage,
          status: data.advertismentOK ? ConsentStatus.Granted : ConsentStatus.Denied,
        }),
        FirebaseAnalytics.setConsent({
          type: ConsentType.AnalyticsStorage,
          status: data.analyticsOK ? ConsentStatus.Granted : ConsentStatus.Denied,
        }),
        FirebaseAnalytics.setConsent({
          type: ConsentType.AdUserData,
          status: data.advertismentOK ? ConsentStatus.Granted : ConsentStatus.Denied,
        }),
        FirebaseAnalytics.setConsent({
          type: ConsentType.AdPersonalization,
          status: data.advertismentOK ? ConsentStatus.Granted : ConsentStatus.Denied,
        }),
      ]);

      if (data.analyticsOK) {
        await this.initializeAnalytics();
      }
    } catch (error) {
      console.error("========== Error setting consent", error);
    }
  }
}
